import { atom } from "recoil";
import { getProfileLocal } from "../../../utils/common";

const courseDataState = atom({
    key: 'courseDataState',
    default: getProfileLocal()?.courses,
});


const actualCourseState = atom({
    key: 'actualCourseState',
    default: getProfileLocal()?.courses?.find(item => item?.enrollment_hash === getProfileLocal()?.enrollment_hash),
});



export { courseDataState, actualCourseState }